import { style } from "@mui/system";
import styled from "styled-components";

export const BoMainV = styled.div`
    background: #fff;
    padding: 15px 15px 0;
    border-radius: 5px;
    color: #fff; 
    box-shadow: 0 0 25px rgb(0 0 0 / 10%);
    position: relative; 
`
export const BoNumbers = styled.div`
    
`

export const BoImg = styled.div`

`